import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { AppLayout } from "@/components/intel/Layout";

export const Route = createFileRoute("/vault/$scanId")({
  component: () => <Outlet />,
  errorComponent: ({ error }) => (
    <AppLayout>
      <div className="p-6 space-y-3">
        <div className="text-sm text-danger">We couldn't open this case: {error.message}</div>
        <Link to="/vault" className="inline-flex rounded-md border border-panel-border bg-panel/40 px-3 py-1.5 text-xs hover:bg-panel/70">
          Back to vault
        </Link>
      </div>
    </AppLayout>
  ),
  notFoundComponent: () => (
    <AppLayout>
      <div className="p-6 space-y-3">
        <div className="text-sm text-muted-foreground">That case isn't in your vault — it may have been deleted.</div>
        <Link to="/vault" className="inline-flex rounded-md border border-panel-border bg-panel/40 px-3 py-1.5 text-xs hover:bg-panel/70">
          Back to vault
        </Link>
      </div>
    </AppLayout>
  ),
});
